// custom-variant-filters.js
(function () {
  // idempotent init guard
  const INIT_FLAG = 'customVariantFiltersInitialized_v2';

  // parse JSON safely and return null on error
  function safeParse(jsonStr) {
    try {
      return JSON.parse(jsonStr);
    } catch (e) {
      return null;
    }
  }

  // Read currently selected filters from the form and return an object { OptionName: [vals...] }
  function readSelectedFilters(form) {
    const filters = {};
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
      const name = cb.name;
      if (!filters[name]) filters[name] = [];
      filters[name].push(cb.value);
    });
    return filters;
  }

  // Apply filters to currently visible product cards
  function applyFiltersToCards(filters, container) {
    const cards = (container || document).querySelectorAll('.card-wrapper');
    cards.forEach(card => {
      const parentLi = card.closest('li') || card.closest('.grid__item') || card.parentElement;
      const data = card.getAttribute('data-variant-options');
      if (!data) {
        // no data -> keep visible
        if (parentLi) parentLi.style.display = '';
        return;
      }
      const parsed = safeParse(data);
      if (!parsed) {
        // bad json -> keep visible but log once
        if (!card.__variant_parse_warned) {
          console.warn('custom-variant-filters: invalid JSON on card', card, data);
          card.__variant_parse_warned = true;
        }
        if (parentLi) parentLi.style.display = '';
        return;
      }

      // support two shapes: array of objects [{Color:"Red",Size:"M"}, ...] or object of arrays {"Color":["Red"]...}
      const cardValues = (Array.isArray(parsed) && parsed.length > 0 && typeof parsed[0] === 'object')
        ? parsed // array of variant objects
        : (function () {
            // convert object-of-arrays into array-of-objects for matching simplicity
            if (parsed && typeof parsed === 'object') {
              // pick unique combinations by zipping arrays (best-effort)
              const optionNames = Object.keys(parsed);
              const length = parsed[optionNames[0]] ? parsed[optionNames[0]].length : 0;
              const arr = [];
              for (let i = 0; i < length; i++) {
                const obj = {};
                optionNames.forEach(n => { obj[n] = parsed[n][i]; });
                arr.push(obj);
              }
              return arr;
            }
            return [];
          })();

      // if no filters selected -> show
      if (!filters || Object.keys(filters).length === 0) {
        if (parentLi) parentLi.style.display = '';
        return;
      }

      // Evaluate: a product should show if there exists at least one variant object
      // that matches every selected group (AND logic between groups, OR within group)
      const matches = cardValues.some(variantObj => {
        return Object.entries(filters).every(([optName, selectedVals]) => {
          // variantObj may have keys with different casing — use exact match (we built from product.options)
          const v = variantObj[optName];
          if (v === undefined) return false;
          return selectedVals.some(val => {
            // numeric and string safe compare
            return String(v) === String(val);
          });
        });
      });

      if (parentLi) parentLi.style.display = matches ? '' : 'none';
    });
  }

  // Update URL query parameters to reflect current filters
  function updateUrlParams(filters) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, vs]) => {
      vs.forEach(v => params.append(k, v));
    });
    const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState(null, '', newUrl);
  }

  // Restore form state from URL query params
  function restoreFromUrl(form) {
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      form.querySelectorAll(`input[name="${key}"][value="${value}"]`).forEach(input => {
        input.checked = true;
      });
    });
  }

  // Attach handlers to the form (single attach; safe to call multiple times)
  function attachFormHandlers(form, container) {
    if (!form) return;

    // remove any existing handler marker
    if (!form.__cvf_attached) {
      form.addEventListener('change', function () {
        const selected = readSelectedFilters(form);
        updateUrlParams(selected);
        applyFiltersToCards(selected, container);
      });
      form.__cvf_attached = true;
    }
  }
  

  // main initializer: finds the snippet container, sets up handlers and applies initial filter state
  function initOnce(contextRoot) {
    const root = contextRoot || document;
    const snippet = root.querySelector('.custom-variant-filters');
    if (!snippet) return false;

    const form = snippet.querySelector('#variant-filter-form') || snippet.querySelector('form');
    if (!form) return false;

    // restore from URL if present
    restoreFromUrl(form);

    // attach handlers
    attachFormHandlers(form, root);

    // apply immediately
    const selected = readSelectedFilters(form);
    applyFiltersToCards(selected, root);
    return true;
  }

  // Public re-init function to be called after Shopify renders sections
  function reinitAll() {
    // try to init on whole document first
    const ok = initOnce(document);
    // also attempt init inside any freshly rendered section containers in the page
    document.querySelectorAll('.shopify-section').forEach(sec => initOnce(sec));
    return ok;
  }

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    reinitAll();
  });

  // Shopify section events (cover multiple Dawn versions)
  ['shopify:section:load', 'shopify:section:render', 'shopify:section:reorder'].forEach(ev =>
    document.addEventListener(ev, function (e) {
      // event.detail may include section id; try to init inside event.target if possible
      const target = (e && e.target) || document;
      initOnce(target);
      // also run global reinit after a tiny delay because sections sometimes inject after event
      setTimeout(reinitAll, 50);
    })
  );

  // Also handle history navigation (back/forward)
  window.addEventListener('popstate', function () {
    setTimeout(reinitAll, 50);
  });

  // Expose for debug
  window.customVariantFilters = {
    reinit: reinitAll,
    applyNow: function() {
      const form = document.querySelector('.custom-variant-filters form');
      const selected = form ? readSelectedFilters(form) : {};
      applyFiltersToCards(selected);
    }
  };

})();




document.addEventListener('DOMContentLoaded', () => {
  const gridContainer = document.querySelector('#ProductGridContainer');
  const filterForm = document.querySelector('form#FacetFiltersForm, form.facets__form');
  const sortSelect = document.querySelector('select[name="sort_by"]');
  let currentPage = 1;

  if (!gridContainer || !filterForm) return;

  // --- Main AJAX loader ---
  function updateCollection(url, pushState = true) {
    gridContainer.classList.add('loading');

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('#ProductGridContainer');
        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
          if (pushState) window.history.pushState({}, '', url.replace('&view=ajax', ''));
          bindPaginationLinks(); // rebind pagination
          window.scrollTo({ top: gridContainer.offsetTop - 80, behavior: 'smooth' });
        }
      })
      .catch(err => console.error('AJAX Filter Error:', err))
      .finally(() => {
        gridContainer.classList.remove('loading');
      });
  }

  // --- Build URL with filters ---
  function buildAjaxUrl(page = 1) {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams(formData);
    if (page > 1) params.set('page', page);
    params.set('view', 'ajax');
    return `${window.location.pathname}?${params.toString()}`;
  }

  // --- Filter change ---
  filterForm.addEventListener('change', e => {
    e.preventDefault();
    currentPage = 1;
    updateCollection(buildAjaxUrl());
  });

  // --- Sort change ---
  sortSelect?.addEventListener('change', e => {
    e.preventDefault();
    currentPage = 1;
    updateCollection(buildAjaxUrl());
  });

  // --- Pagination click ---
  function bindPaginationLinks() {
    const links = gridContainer.querySelectorAll('.pagination a');
    links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const url = new URL(link.href);
        const pageParam = url.searchParams.get('page') || '1';
        currentPage = parseInt(pageParam);
        updateCollection(buildAjaxUrl(currentPage));
      });
    });
  }

  // Initial pagination binding
  bindPaginationLinks();

  // --- Back/forward button support ---
  window.addEventListener('popstate', () => {
    updateCollection(buildAjaxUrl(currentPage), false);
  });
});



